module.exports = __webpack_public_path__ + "media/images/plans/ceremony/hall-list/plan-ceremony-lineup-kansai-1-16bdb42596a1ef460a16304541bd5a37.png";